import { AxiosResponse } from 'axios';
import { SET_LEAVE_REQUESTS, SET_LEAVE_REQUEST, SET_ERRORMSG, SET_LEAVE_STATS } from '@/store/mutation_types';
import {
  CLEAR_LEAVE_REQUEST_ISLOADING,
  DELETE_LEAVE_REQUEST,
  EDIT_LEAVE_REQUEST,
  GET_LEAVE_REQUESTS,
  GET_LEAVE_REQUEST,
  REGISTER_LEAVE_REQUEST,
  APPROVE_LEAVE_REQUEST,
  REJECT_LEAVE_REQUEST,
  GET_LEAVE_STATS,
  CANCEL_LEAVE_REQUEST,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import LeaveRequest from '@/services/leave_request';
import { Module } from 'vuex';
import { EditLeaveRequest, RegisterLeaveRequest, GetLeaveRequest } from '@/dtos/leave_request.dto';

const leaveRequest: Module<any, {}> = {
  state: {
    leaveRequest: {
      data: null,
      isLoading: false,
    },
    leaveRequests: {
      data: null,
      isLoading: false,
    },
    leaveStats: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    leaveRequest: (state: { leaveRequest: any }) => state.leaveRequest,
    leaveRequests: (state: { leaveRequests: any }) => state.leaveRequests,
    leaveStats: (state: { leaveStats: any }) => state.leaveStats,
  },
  mutations: {
    [SET_LEAVE_REQUEST]: (
      state: { leaveRequest: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.leaveRequest.data = payload.data) : null,
        (state.leaveRequest.isLoading = payload.isLoading);
    },
    [SET_LEAVE_REQUESTS]: (
      state: { leaveRequests: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.leaveRequests.data = payload.data) : null,
        (state.leaveRequests.isLoading = payload.isLoading);
    },
    [SET_LEAVE_STATS]: (
      state: { leaveStats: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.leaveStats.data = payload.data) : null,
        (state.leaveStats.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_LEAVE_REQUEST]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_REQUEST, { data: { id: payload.id }, isLoading: true });

      const result: AxiosResponse = await LeaveRequest.registerLeaveRequest(
        payload as RegisterLeaveRequest
      );

      if (result) {
        if (result.data.status) {
          commit(SET_LEAVE_REQUEST, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_REQUEST, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_REQUEST, { isLoading: false });
        return false;
      }
    },
    [GET_LEAVE_REQUESTS]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_REQUESTS, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveRequest.getLeaveRequests(
        payload as GetLeaveRequest
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_LEAVE_REQUESTS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_REQUESTS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_REQUESTS, { isLoading: false });
        return false;
      }
    },
    [GET_LEAVE_REQUEST]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_REQUESTS, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveRequest.getLeaveRequests(
        payload as GetLeaveRequest
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_LEAVE_REQUESTS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_REQUESTS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_REQUESTS, { isLoading: false });
        return false;
      }
    },
    [GET_LEAVE_STATS]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_STATS, { data: null, isLoading: true });

      const result: AxiosResponse = await LeaveRequest.getLeaveStats(
        payload as GetLeaveRequest
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_LEAVE_STATS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_STATS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_STATS, { isLoading: false });
        return false;
      }
    },
    [EDIT_LEAVE_REQUEST]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_REQUEST, { data: { id: payload.id }, isLoading: true });

      const result: AxiosResponse = await LeaveRequest.editLeaveRequest(
        payload as EditLeaveRequest
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_LEAVE_REQUEST, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_REQUEST, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_REQUEST, { isLoading: false });
        return false;
      }
    },
    [APPROVE_LEAVE_REQUEST]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_REQUEST, { data: { id: payload.id }, isLoading: true });

      const result: AxiosResponse = await LeaveRequest.approveLeaveRequest(
        payload as EditLeaveRequest
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_LEAVE_REQUEST, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_REQUEST, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_REQUEST, { isLoading: false });
        return false;
      }
    },
    [REJECT_LEAVE_REQUEST]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_REQUEST, { data: { id: payload.id }, isLoading: true });

      const result: AxiosResponse = await LeaveRequest.rejectLeaveRequest(
        payload as EditLeaveRequest
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_LEAVE_REQUEST, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_REQUEST, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_REQUEST, { isLoading: false });
        return false;
      }
    },
    [CANCEL_LEAVE_REQUEST]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAVE_REQUEST, { data: { id: payload.id }, isLoading: true });

      const result: AxiosResponse = await LeaveRequest.cancelLeaveRequest(
        payload as EditLeaveRequest
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_LEAVE_REQUEST, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_REQUEST, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_REQUEST, { isLoading: false });
        return false;
      }
    },
    [DELETE_LEAVE_REQUEST]: async ({ commit }: any, payload: string) => {
      commit(SET_LEAVE_REQUEST, { data: { id: payload }, isLoading: true });

      const result: AxiosResponse = await LeaveRequest.deleteLeaveRequest(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_LEAVE_REQUEST, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_LEAVE_REQUEST, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_LEAVE_REQUEST, { isLoading: false });
        return false;
      }
    },
    [CLEAR_LEAVE_REQUEST_ISLOADING]: ({ commit }) => {
      commit(SET_LEAVE_REQUEST, { isLoading: false });
      commit(SET_LEAVE_REQUESTS, { isLoading: false });
    },
  },
};

export default leaveRequest;
